import { Replay } from "@mui/icons-material";

import ButtonIconContainer from "../../../ButtonIconContainer/ButtonIconContainer";

type ButtonReplayProps = {
  onClickReplay: () => void;
};

export default function ButtonReplay({ onClickReplay }: ButtonReplayProps): React.ReactElement {
  return (
    <ButtonIconContainer onClick={onClickReplay} ariaLabel="replay" tooltip="Replay (j)" id="button_replay">
      <Replay />
    </ButtonIconContainer>
  );
}
